import { useEffect, useMemo, useState } from 'react';
import LoginPage from './pages/LoginPage';
import MainPage from './pages/MainPage';
import { version } from "./components/Constants";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

function App() {
  
  const [loginPage, setLoginPage] = useState(!localStorage.getItem("jwt_token"));
  const [mode, setMode] = useState("light");
  const theme = useMemo(() =>
    createTheme({
      palette: {
        mode: mode, 
      },
    }), [mode]
  );

  const toggleTheme = () => {
    setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
  };

  const loginSuccess = () => {
    setLoginPage(false);
  };

  const loginFailure = () => {
    localStorage.clear();
    setLoginPage(true);
  };

  useEffect(() => {
    document.title = "Fota " + version;
    const handleUnauthorized = () => {
      console.warn("Unauthorized! Redirecting to login...");
      loginFailure();
    };
    window.addEventListener("user-unauthorized", handleUnauthorized);
    return () => {
      window.removeEventListener("user-unauthorized", handleUnauthorized);
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {loginPage ? <LoginPage loginSuccess={loginSuccess} /> : <MainPage loginFailure={loginFailure} toggleTheme={toggleTheme} mode={mode}/>}
    </ThemeProvider>
  );
}

export default App;
